import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, CircularProgressBar, Stack, Typography, } from '../../atoms';
import { useIsMobile } from '../../hooks';
import { styled } from '../../legacy/utils';
export function MobileStepNavigation({ children, first, title, labelNext, onClickNext, onClickPrev, disabledNext, disabledPrev, loadingNext, loadingPrev, nextButtonIcon, progress = 0, progressBar = false, titleColor = 'zurichBlue', }) {
    const isMobile = useIsMobile();
    return (_jsxs(Stack, { alignItems: "center", my: (theme) => theme.spacing(-2), children: [_jsxs(ContainerStyled, { children: [_jsxs(StackStyled, { columnGap: 3, children: [!first && (_jsx(Button, { loading: loadingPrev, disabled: disabledPrev, onClick: onClickPrev, icon: "arrow-left-1", variant: "text" })), !!title && (_jsx(Typography, { variant: isMobile ? 'body1 semibold' : 'h5', color: titleColor, children: title })), progressBar && !first && _jsx(CircularProgressBar, { progress: progress })] }), _jsx(Stack, { children: children }), _jsx(DivStyled, {})] }), _jsx(NavStackStyled, { children: _jsx(Button, { icon: nextButtonIcon, loading: loadingNext, disabled: disabledNext || loadingNext, onClick: onClickNext, children: labelNext }) })] }));
}
const DivStyled = styled('div')(() => ({
    flex: '1 1',
}));
const NavStackStyled = styled(Stack)(({ theme }) => ({
    position: 'sticky',
    alignItems: 'center',
    width: '100vw',
    zIndex: '100',
    bottom: '0px',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    borderTop: `1px solid ${theme.palette.groupPrimary.lightDove}`,
    [theme.breakpoints.down('lg')]: {
        alignItems: 'flex-end',
        padding: theme.spacing(2),
    },
    [theme.breakpoints.down('sm')]: {
        alignItems: 'center',
    },
}));
const StackStyled = styled(Stack)(({ theme }) => ({
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    minWidth: '300px',
    position: 'sticky',
    top: '0px',
    height: theme.spacing(4),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    paddingRight: theme.spacing(2),
    zIndex: '100',
    backgroundColor: theme.palette.groupPrimary.aliceBlue,
}));
const ContainerStyled = styled(Stack)(({ theme }) => ({
    height: 'auto',
    display: 'inline-block',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0',
    paddingTop: theme.spacing(2),
    minWidth: '300px',
    minHeight: 'calc(100vh - 70px)',
    [theme.breakpoints.down('lg')]: {
        maxWidth: '800px',
    },
    [theme.breakpoints.down('sm')]: {
        maxWidth: '600px',
    },
    width: '100%',
}));
